import React, { useCallback, useEffect, useState } from 'react';
import { ATMField, ATMGrid, ATMToggle } from 'shared-it-appmod-ui';
import Confirm from 'src/components/atoms/confirm/confirm.component';
import { useAdHocSpendFileContext } from 'src/contexts/ad-hoc-spend-file.context';
import { useContractorContext } from 'src/contexts/contractor.context';
import { usePOGuardrailsContext } from 'src/contexts/po-guardrails.context';
import Lang from 'src/libraries/language';
import { FunctionalityDisableText } from '../../constant/message-constant.component';

const NotFoundInSCHToggle: React.FC = () => {
  const [openAuditLog, setOpenAuidtLog] = useState<boolean>(false);
  const [isConfirm, setIsConfirm] = useState(false);
  const { state, actions } = useAdHocSpendFileContext();
  const [spendAutoGenerationStateDisable, setSpendAutoGenerationStateDisable] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const { state: schFileState, actions: schFileActions } = useContractorContext();
  const { state: poState, actions: poActions } = usePOGuardrailsContext();
  const [isSCHFileRunning, setSCHFileRunnig] = useState(false);
  const [isPOValidationBatchJobRunning, setPOValidationBatchJobRunnig] = useState(false);
  const [isEnableFunctionality, setEnableFunctionality] = useState(false);
  const [isDisableFunctionality, setDisableFunctionality] = useState(false);

  const checkSCHFileStatus = async () => {
    const response = await schFileActions.schFileStatusGet();
    if (response.payload?.status) {
      setSCHFileRunnig(response.payload?.data.isInProgress)
    }
  };

  const checkPOValidationBatchJobStatus = async () => {
    const response = await poActions.getPOValidationBatchJobStatus();
    if (response.payload?.status) {
      setPOValidationBatchJobRunnig(response.payload?.data.isInProgress)
    }
  };

  useEffect(() => {
    if (isSCHFileRunning || isPOValidationBatchJobRunning) {
      setDisableFunctionality(true)
    } else {
      setDisableFunctionality(false)
    }
  }, [isSCHFileRunning, isPOValidationBatchJobRunning])

  useEffect(() => {
    checkSCHFileStatus();
    checkPOValidationBatchJobStatus();
    fetchData();
  }, []);

  const handleToggle = () => {
    setIsConfirm(true);
  }

  const fetchData = async () => {
    setLoading(true);
    const data = await schFileActions.getNotFoundInSCHFlag();
    setEnableFunctionality(!data.payload?.data?.isAllowed)
    setLoading(false)
  }

  const handleConfirm = useCallback(async () => {
    const params = {
      "isAllowIfNotInSch": isEnableFunctionality
    }
    await schFileActions.updateNotFoundInSCHFlag(params);
    setIsConfirm(false);
    fetchData();
  }, [actions, isEnableFunctionality]);

  const handleOnCloseConfirm = useCallback(async () => {
    setIsConfirm(false);
  }, []);

  return isDisableFunctionality ? (<div style={{
    display: 'flex',
    width: '100%',
    height: '100px',
    justifyContent: 'center',
    alignItems: 'center'
  }
  } >
    <FunctionalityDisableText />
  </div >) : (<div>
    {isConfirm && (
      <Confirm
        open={isConfirm}
        size="tiny"
        content={isEnableFunctionality ? Lang.MSG_NOT_FOUND_IN_SCH_FLAG_DISABLE_CONFIRM : Lang.MSG_NOT_FOUND_IN_SCH_FLAG_ENABLE_CONFIRM}
        loading={false}
        btn_text={Lang.LBL_CONFIRM_BTN}
        header={Lang.TTL_CONFIRMATION}
        onCancel={handleOnCloseConfirm}
        onConfirm={() => handleConfirm()}
      />
    )}

    <ATMGrid columns={1}>
      <ATMGrid.Row >
        <ATMGrid.Column style={{ textAlign: 'center', paddingTop: '25px', paddingBottom: '25px', display: 'flex', justifyContent: 'center' }}>
          <b>{isEnableFunctionality ? 'Disable Not Found in SCH Flag' : 'Enable Not Found in SCH Flag'}</b>
          <ATMField
            id="ATMToggle"
            as={ATMToggle}
            name="active"
            style={{ marginLeft: '15px' }}
            defaultChecked={isEnableFunctionality}
            checked={isEnableFunctionality}
            onChange={(event) => {
              handleToggle()
            }}
          />
        </ATMGrid.Column>
      </ATMGrid.Row>
    </ATMGrid>
  </div>)

}

export default NotFoundInSCHToggle